import React from "react";
import styles from "./HowToCompress.module.css";

const HowToCompress = () => {
  return (
    <div className={styles.howToContainer}>
      <h1 className={styles.howToTitle}>How to Enlarge & Compress Images</h1>
      <ol className={styles.howToList}>
        <li>
          <span className={styles.highlight}>Upload your image</span> by
          selecting "Browse Files" or simply dragging and dropping in the area
        </li>
        <li>
          <span className={styles.highlight}>
            Adjust the compression settings
          </span>
          :
          <ul className={styles.subList}>
            <li>Set the quality level (1-100%)</li>
            <li>Optional specify your width/height you want to enlarge</li>
            <li>Select if you want to keep aspect ratio</li>
          </ul>
        </li>
        <li>
          Click <span className={styles.highlight}>"Compress Image"</span> when
          you're ready to complete the file
        </li>
        <li>
          <span className={styles.highlight}>
            Preview and "Download" button
          </span>{" "}
          to download your optimized image
        </li>
      </ol>
      <div className={styles.supportedFormats}>
        <h3>Supported Formats</h3>
        <p>JPG, JPEG, PNG</p>
        <p>
          All processing happens in your browser – your images never leave your
          device!
        </p>
      </div>
    </div>
  );
};

export default HowToCompress;
